import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import SidebarLayout from '../../components/layout/sidebarLayout';
import {
  settingsSidebarContent,
  findSelectionForPath,
  buildSettingsPath,
  DEFAULT_SETTINGS_PATH,
} from '../../constants/sidebarContent';
import { useAuth0 } from '@auth0/auth0-react';
import { canUserAccess } from '../../utils/userAuthorization';

const Settings = () => {
  const navigate = useNavigate();
  const { user } = useAuth0();
  const [selected, setSelected] = useState<[number, number] | null>(null);
  const menuState = selected !== null;
  const { '*': splat } = useParams();

  useEffect(() => {
    if (!splat) {
      navigate(DEFAULT_SETTINGS_PATH, { replace: true });
      return;
    }

    const option = splat.split('/')[0];
    const selection = findSelectionForPath(option, settingsSidebarContent);

    if (
      selection === null ||
      !canUserAccess(user?.sub, settingsSidebarContent[selection[0]].titles[selection[1]].allowedUserIds)
    ) {
      navigate(DEFAULT_SETTINGS_PATH, { replace: true });
      return;
    }

    setSelected(selection);
  }, [splat, navigate, user?.sub]);

  const onSetSelected = (array: [number, number]) => {
    navigate(buildSettingsPath(array));
  };

  return (
    <SidebarLayout
      selected={selected}
      onSelect={onSetSelected}
      sidebarContent={settingsSidebarContent}
    >
      {menuState && selected && canUserAccess(
        user?.sub,
        settingsSidebarContent[selected[0]].titles[selected[1]].allowedUserIds
      ) && settingsSidebarContent[selected[0]].titles[selected[1]].content}
    </SidebarLayout>
  );
};

export default Settings;
